module.exports = __webpack_public_path__ + "img/symbol_0.36dd4212.png";